/**
 * Checks whether the given action has an error. If so, cast to an error action.
 * @param action The action to check.
 */
var isError = function (action) { return !!action.error; };

export { isError };
